import { createSlice } from "@reduxjs/toolkit";

const sellSlice = createSlice({
  name: "sell",
  initialState: {
    loading: false,
    data: null,
    error: null,
    sellCreated: false,
  },
  reducers: {
    getSellHistoryRequest: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    getSellHistorySuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload.data || null;
    },
    getSellHistoryFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    createSellRequest: (state) => {
      state.loading = true;
      state.error = null;
      state.sellCreated = false;
    },
    createSellSuccess: (state) => {
      state.loading = false;
      state.sellCreated = true; 
    },
    createSellFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.sellCreated = false; 
    },
    resetSellState: (state) => {
      state.sellCreated = false;
    },
  },
});

export const {
  getSellHistoryRequest,
  getSellHistorySuccess,
  getSellHistoryFailure,
  createSellRequest,
  createSellSuccess,
  createSellFailure,
  resetSellState,

} = sellSlice.actions;

export default sellSlice.reducer;
